import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Translation resources - will be loaded from separate files
import enCommon from '../locales/en/common.json'
import enAuth from '../locales/en/auth.json'
import enDashboard from '../locales/en/dashboard.json'
import enAdmin from '../locales/en/admin.json'

import esCommon from '../locales/es/common.json'
import esAuth from '../locales/es/auth.json'
import esDashboard from '../locales/es/dashboard.json'
import esAdmin from '../locales/es/admin.json'

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    admin: enAdmin
  },
  es: {
    common: esCommon,
    auth: esAuth,
    dashboard: esDashboard,
    admin: esAdmin
  }
}

i18n
  .use(initReactI18next) // React integration
  .init({
    resources,

    // Always start in English; authenticated users can restore their own saved preference.
    lng: 'en',

    // Fallback language
    fallbackLng: 'en',
    
    // Default namespace
    defaultNS: 'common',
    
    // Namespace separation
    ns: ['common', 'auth', 'dashboard', 'admin'],
    
    // Key separator and namespace separator
    keySeparator: '.',
    nsSeparator: ':',
    
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Debug mode (only in development)
    debug: process.env.NODE_ENV === 'development',
    
    // React options
    react: {
      useSuspense: false, // Don't use Suspense for loading
    }
  })

export default i18n
